export const ACTION_BASE = 'VISUAL';
